var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendar2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_month_black_24dp_1_",
    "data-name": "calendar_month_black_24dp (1)",
    transform: "translate(0.189 0.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3411",
    "data-name": "Rectangle 3411",
    width: 21,
    height: 21,
    transform: "translate(-0.189 -0.189)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189",
    transform: "translate(2.638 1.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8379",
    "data-name": "Path 8379",
    d: "M17.07,3.759h-.879V2H14.432V3.759H7.4V2H5.638V3.759H4.759a1.751,1.751,0,0,0-1.75,1.759L3,17.829a1.758,1.758,0,0,0,1.759,1.759H17.07a1.764,1.764,0,0,0,1.759-1.759V5.518A1.764,1.764,0,0,0,17.07,3.759Zm0,14.07H4.759V9.035H17.07ZM8.276,12.553H6.518V10.794H8.276Zm3.518,0H10.035V10.794h1.759Zm3.518,0H13.553V10.794h1.759ZM8.276,16.07H6.518V14.311H8.276Zm3.518,0H10.035V14.311h1.759Zm3.518,0H13.553V14.311h1.759Z",
    transform: "translate(-3 -2)",
    fill: "#f8f9ff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar_2.088cecbd.svg";
export { ForwardRef as ReactComponent };